var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.UserSystem.appleUser())?_c('v-slide-group',{attrs:{"selected-class":"bg-success","show-arrows":""}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }